document.addEventListener('DOMContentLoaded', function() {
  const descriptionContainer = document.querySelector('.product-description-container');
  const readMoreButton = document.querySelector('.read-more-button');

  if (descriptionContainer && readMoreButton) {
    readMoreButton.addEventListener('click', function() {
      if (descriptionContainer.classList.contains('expanded')) {
        // Collapsing
        descriptionContainer.style.maxHeight = descriptionContainer.scrollHeight + 'px';
        setTimeout(() => {
          descriptionContainer.classList.remove('expanded');
          descriptionContainer.style.maxHeight = '200px';
        }, 10);
        readMoreButton.textContent = 'Read more';
      } else {
        // Expanding
        descriptionContainer.classList.add('expanded');
        descriptionContainer.style.maxHeight = descriptionContainer.scrollHeight + 'px';
        setTimeout(() => {
          descriptionContainer.style.maxHeight = 'fit-content';
        }, 500); // Match this with the transition duration in CSS
        readMoreButton.textContent = 'Read less';
      }
    });

    // Hide the button if the content is shorter than the container
    if (descriptionContainer.scrollHeight <= 200) { // Match this with the initial max-height in CSS
      readMoreButton.style.display = 'none';
    }
  }
});